export const SEARCH_STACK_NAVIGATOR_SCREEN_OPTIONS = {
  headerShown: false,
  cardStyle: {
    flex: 1,
  },
}
